import React from 'react';
import clsx from 'clsx';
export default function AccountWrapper({
  children,
  type,
}: {
  children: React.ReactNode;
  type?: string;
}) {
  return (
    <>
      <div className="flex justify-center my-24 px-4">
        <div
          className={clsx(
            'w-full md:p-10',
            type === 'wide' ? 'max-w-7xl' : 'max-w-xl',
          )}
        >
          <div className="rounded-lg bg-hk-gray p-6 overflow-hidden">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
